import { useState, useEffect } from "react";
import { flushSync } from "react-dom";

// true mientras se imprime. Los gráficos de recharts (ResponsiveContainer)
// toman el ancho de la pantalla y no alcanzan a achicarse al del papel: sin
// esto, al imprimir salían cortados a la derecha. Con `printing` el gráfico
// se dibuja con un ancho fijo que entra en la hoja. flushSync: el navegador
// arma la impresión apenas termina `beforeprint`, no espera otro render.
export function usePrinting() {
  const [printing, setPrinting] = useState(false);

  useEffect(() => {
    const on = () => flushSync(() => setPrinting(true));
    const off = () => setPrinting(false);
    const media = window.matchMedia("print");
    const onMedia = (event) => (event.matches ? on() : off());
    window.addEventListener("beforeprint", on);
    window.addEventListener("afterprint", off);
    media.addEventListener("change", onMedia);
    return () => {
      window.removeEventListener("beforeprint", on);
      window.removeEventListener("afterprint", off);
      media.removeEventListener("change", onMedia);
    };
  }, []);

  return printing;
}
